import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between space functional usage and cluster',
    name: 'Space Cluster Functionalization',
    partialId: PartialId.Standard.create('space_cluster_funcl'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
